import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import CategoryHero from '@/pages/category/components/CategoryHero';
import CategoryGrid from '@/pages/category/components/CategoryGrid';
import Testimonials from '@/pages/category/components/Testimonials';
import { categoryData, testimonials } from '@/mocks/category';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const cat = slug ? categoryData[slug as keyof typeof categoryData] : null;

  if (!cat) {
    return (
      <>
        <PageMeta title="分类未找到 - 51黑料吃瓜网" description="您访问的分类不存在" />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-32 pb-16 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium">返回首页</Link>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51heiliaochigua.com' },
      { '@type': 'ListItem', position: 2, name: cat.name, item: `https://51heiliaochigua.com/category/${slug}` },
    ],
  };

  return (
    <>
      <PageMeta
        title={`${cat.name} - 51黑料吃瓜网 | 51爆料网`}
        description={`51黑料吃瓜网${cat.name}分类，${cat.description}。汇聚全网最新最热${cat.name}资讯，24小时实时更新。`}
        keywords={`${cat.name},51黑料吃瓜网,51爆料网,吃瓜群众,娱乐圈八卦,网红大瓜`}
        canonical={`https://51heiliaochigua.com/category/${slug}`}
        ogTitle={`${cat.name} - 51黑料吃瓜网`}
        ogDescription={cat.description}
        ogUrl={`https://51heiliaochigua.com/category/${slug}`}
        jsonLdScripts={[breadcrumbJsonLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <nav className="pt-20 md:pt-28 px-6 md:px-10 max-w-6xl mx-auto" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
            <li><Link to="/" className="hover:text-foreground-950 transition-colors">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-[10px]"></i></li>
            <li className="text-foreground-950 font-medium">{cat.name}</li>
          </ol>
        </nav>

        <main>
          <article>
            <CategoryHero
              name={cat.name}
              description={cat.description}
              image={cat.image}
              slug={slug || ''}
            />
            <CategoryGrid items={cat.items} categoryName={cat.name} />
            <Testimonials testimonials={testimonials} />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}